import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { CsvService } from 'core/services/csv.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'lms-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  @Input() public serviceProvider;
  @Input() reportFields;
  public report: any;
  flatReport: any;
  constructor(public route: ActivatedRoute, public csvService: CsvService) {}

  onError() {}

  ngOnInit() {
    this.route.paramMap
      .pipe(switchMap((params: ParamMap) => this.serviceProvider.getReport(params.get('id'))))
      .subscribe((report) => {
        this.report = report;
        this.flatReport = this.serviceProvider.flattenReport(report);
      });
  }

  filterReport(data) {
    const filteredData = [];
    data.forEach((row) => {
      const newRow = {};
      this.reportFields.forEach((fieldName) => {
        newRow[fieldName] = row[fieldName];
      });
      filteredData.push(newRow);
    });
    return filteredData;
  }
  downloadCSV(data) {
    this.csvService.dataToCsv(data, 'csvFile');
  }

  downloadListCSV() {
    this.downloadCSV(this.filterReport(this.flatReport));
  }

  getReportRowChild(licenseId) {
    const reportResult = [];
    if (this.report.licenseResumes) {
      const licenseResume = Object.assign(
        {},
        this.report.licenseResumes.find((reportLicenseResume) => reportLicenseResume.licenseId === licenseId)
      );

      licenseResume.sessions.forEach((session) => {
        const reportRow = Object.assign(session, session.values);
        delete reportRow.values;

        reportResult.push(reportRow);
      });
    }
    return reportResult;
  }
}
